import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { DATE_FORMATS } from "@/lib/status";
import { usePractice } from "@/pages/StaffApp";

const SAMPLE = { "MM/DD/YYYY": "11/25/2026", "DD/MM/YYYY": "25/11/2026", "YYYY-MM-DD": "2026-11-25" };

export default function PracticeSettings() {
  const { practice, reloadPractice } = usePractice();
  const [df, setDf] = useState(practice.date_format || "MM/DD/YYYY");
  const save = async () => {
    try { await api.put("/practice/settings", { date_format: df }); toast.success("Date format saved"); reloadPractice(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="bg-white border rounded-xl p-5 space-y-4" data-testid="practice-settings">
      <div><h2 className="text-lg font-semibold">Date format</h2>
        <p className="text-sm text-slate-600">Used on every screen, on signing pages and on signed PDFs for {practice.name}.</p></div>
      <div className="grid gap-2" role="radiogroup">
        {DATE_FORMATS.map((f) => (
          <label key={f} className={`flex items-center gap-3 rounded-lg border p-3 cursor-pointer transition-colors ${df === f ? "border-[var(--brand)] bg-[var(--brand-soft)]" : ""}`}>
            <input type="radio" name="df" checked={df === f} onChange={() => setDf(f)} data-testid={`date-format-${f}`} />
            <span className="font-mono font-semibold">{f}</span><span className="text-sm text-slate-500 ml-auto">e.g. {SAMPLE[f]}</span>
          </label>))}
      </div>
      <Button className="btn-brand" disabled={df === (practice.date_format || "MM/DD/YYYY")} onClick={save} data-testid="date-format-save">Save</Button>
    </div>
  );
}
